/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type BaseAccidentReviewAnalysisDefinitionDto = {
    createdBy?: string;
    createdDate?: string;
    lastModifiedBy?: string;
    lastModifiedDate?: string;
    deleted?: boolean;
    id?: string;
    firmId?: string;
    predefinedId?: string;
    source?: BaseAccidentReviewAnalysisDefinitionDto.source;
    label?: string;
}

export namespace BaseAccidentReviewAnalysisDefinitionDto {

    export enum source {
        SYSTEM = 'SYSTEM',
        USER_DEFINED = 'USER_DEFINED',
    }


}
